module.exports = __webpack_public_path__ + "img/community_map_packs.1ddf1cae.png";